import { ICurrencyList, IGetCurrencyDTO, ISettings, ISettingsDTO } from 'shared/models/Settings'
import { FeatureFlagsMap, FeatureFlagsResponse } from 'shared/utils/featureFlags'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { SettingsConverter } from './SettingsConverter'

class SettingsApi extends BaseHttpService {
  private converter

  private featureFlags

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/settings`
    this.featureFlags = `${baseUrl}/api/feature-flags`
    this.converter = new SettingsConverter()
  }

  async getSettings() {
    return this.sendQuery<ISettingsDTO, ISettings>({
      url: `${this.baseUrl}/`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertSettings,
    })
  }

  async getFeatureFlags() {
    return this.sendQuery<FeatureFlagsResponse, { featureFlags: FeatureFlagsMap }>({
      url: `${this.featureFlags}/`,
      type: QueryTypes.GET,
      converterSuccess: this.converter.convertFeatureFlags,
    })
  }

  async getCurrencies() {
    return this.sendQuery<IGetCurrencyDTO, ICurrencyList>({
      url: `${this.baseUrl}/currency-list/`,
      type: QueryTypes.GET,
    })
  }
}

export default SettingsApi
